export default __webpack_public_path__ + "static/media/services01.0aa418cc.png";